import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
`;

export const FlexCol = styled.div`
  display: flex;
  width: 100%;
  flex-direction: col;
`;
